import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { CronologiaStatoDTO } from '../../models/cronologiaStato-dto';
import { PagamentiService } from '../../service/pagamenti.service';

@Component({
  selector: 'lib-tabella-cronologica-stati',
  templateUrl: './tabella-cronologica-stati.component.html',
  styleUrls: ['./tabella-cronologica-stati.component.css']
})
export class TabellaCronologicaStatiComponent implements OnInit {
  @Input()
  idPagamento: string;
  cronologiaStati$: Observable<Array<CronologiaStatoDTO>>;

  constructor(private pagamentiService: PagamentiService) { }

  ngOnInit(): void {
    this.cronologiaStati$ = this.pagamentiService.getCronologiaStati$(this.idPagamento);
  }

}
